import isFlagOn from '../../shared/utilities/isFlagOn.function'

const getPhone = (subsiteData, callback) => {
  callback = callback && typeof callback === 'function' ? callback : p => p

  if (subsiteData?.s_phone_override) return callback(subsiteData.s_phone_override)

  if (subsiteData?.u_phone) return callback(subsiteData.u_phone)

  return false
}

const getMobilePhone = (subsiteData, callback) => {
  callback = callback && typeof callback === 'function' ? callback : p => p

  if (!isFlagOn(subsiteData?.s_mobile_phone_show)) return false

  if (subsiteData?.u_mobile) return callback(subsiteData.u_mobile)

  return false
}

const getFirstName = subsiteData => (subsiteData?.u_nickname || subsiteData?.u_fname || '').trim()

const getFullName = subsiteData =>
  [getFirstName(subsiteData), subsiteData?.u_lname]
    .filter(n => n)
    .join(' ')
    .trim()

const getLocation = subsiteData => {
  const city = `${subsiteData?.u_city || ''}`.trim()
  const state = `${subsiteData?.u_state || ''}`.trim()
  if (city && state) return `${city}, ${state}`
  return city || state || ''
}

const getEmail = subsiteData => {
  if (subsiteData?.s_email_override) return subsiteData.s_email_override

  if (subsiteData?.u_company_email) return subsiteData.u_company_email

  if (subsiteData?.u_quote_email) return subsiteData.u_quote_email

  if (subsiteData?.u_email) return subsiteData.u_email

  return false
}

export { getPhone, getMobilePhone, getEmail, getFirstName, getFullName, getLocation }
